import React, { Component } from "react";
import { Grid, Row, Col, Modal, Table, ListGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { Card } from "components/Card/Card.jsx";
import { PersianNumber } from "@thg303/react-persian";
import PersianDate from "persian-date";
import Button from "components/CustomButton/CustomButton.jsx";
import xlsx from "xlsx-populate/browser/xlsx-populate";
import { saveAs } from "file-saver";
import { base_url } from "../../redux/constants/routes";
import { Link } from "react-router-dom";

const mapStateToProps = (state) => {
  return {
    selectedCustomer: state.selectedCustomer,
    selectedOrder: (function () {
      return {
        ...state.selectedOrder,
        services: state.selectedOrder.services.map((ser, key) => {
          if (ser.service) {
            return (ser = { ...ser, ...ser.service });
          } else return ser;
        }),
      };
    })(),
    datafile: state.datafile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

function ExportExcelLink({ orderId }) {
  const token = localStorage.getItem("token");
  const url = `${base_url}/order/export-excel/${orderId}?token=${token}`;

  return (
    <Row>
      <Col xs={6}>
        <a
          href={url}
          target="_blank"
          className="btn btn-info"
          style={{ float: "right" }}
        >
          دانلود فاکتور
        </a>
      </Col>
    </Row>
  );
}

class SingleOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getName = this.getName.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.dataURItoBlob = this.dataURItoBlob.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
    this.fillExcelInvoiceWithData = this.fillExcelInvoiceWithData.bind(this);
  }

  exportExcel() {
    const fileName = this.getName();
    console.log(this.props.datafile);
    return;
    const excelBlob = this.dataURItoBlob(this.props.datafile);
    console.log(this.props.datafile);
    return;
    this.downloadExcel(excelBlob, fileName);
  }

  dataURItoBlob(dataURI) {
    dataURI = decodeURIComponent(dataURI);
    console.log(dataURI);
    const [header, data] = dataURI.split(",");
    const isBase64 = header.indexOf("base64") >= 0;
    const byteString = isBase64 ? atob(data) : unescape(data);
    const mimeString = header.split(":")[1].split(";")[0];

    const buffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(buffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }

    return new Blob([buffer], { type: mimeString });
  }

  fillExcelInvoiceWithData(workbook) {
    const sheet = workbook.sheet("Sheet1");
    const { selectedCustomer, selectedOrder } = this.props;
    const { services } = selectedOrder;

    sheet
      .cell("D5")
      .value(
        `خانم/آقای: ${selectedCustomer.firstName || ""} ${
          selectedCustomer.lastName || ""
        }`
      );
    sheet.cell("D7").value(selectedOrder.address);
    sheet
      .cell("N4")
      .value(new PersianDate(selectedOrder.date).format("YYYY/MM/DD"));
    sheet.cell("D6").value(selectedCustomer.phone);
    sheet.cell("N6").value(selectedCustomer.call);
    sheet.cell("I13").value(selectedOrder.invoice_number || 0);
    sheet.cell("N23").value(selectedOrder.transportation || 0);
    sheet.cell("N5").value(selectedCustomer.code || 0);

    services.slice(0, 10).forEach((service, index) => {
      const baseRow = 12 + index;
      sheet.cell(`C${baseRow}`).value(service.name);
      sheet.cell(`M${baseRow}`).value(parseFloat(service.price));
      sheet.cell(`E${baseRow}`).value(parseFloat(service.count));
      sheet.cell(`L${baseRow}`).value(parseFloat(service.area) || 1);
    });

    return workbook;
  }

  downloadExcel(blob, fileName) {
    xlsx
      .fromDataAsync(blob)
      .then((workbook) => this.fillExcelInvoiceWithData(workbook))
      .then((workbook) => workbook.outputAsync())
      .then((data) => saveAs(data, fileName));
  }

  getName() {
    const { selectedOrder } = this.props;
    return `شماره سفارش ${selectedOrder.id}`;
  }

  render() {
    return (
      <Row>
        <Col md={12}>
          <Card
            title={this.getName()}
            content={
              <div>
                <Row>
                  <Col xs={6}>
                    <span style={{ fontWeight: "bold" }}>آدرس: </span>
                    {this.props.selectedOrder.address}
                  </Col>
                  <Col xs={6}>
                    <span style={{ fontWeight: "bold" }}>تلفن همراه: </span>
                    <PersianNumber>
                      {this.props.selectedCustomer.call}
                    </PersianNumber>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <span style={{ fontWeight: "bold" }}>کد صنفی: </span>
                    <PersianNumber>
                      {this.props.selectedOrder.code_senfi}
                    </PersianNumber>
                  </Col>
                  <Col xs={6}>
                    <span style={{ fontWeight: "bold" }}>شماره فاکتور: </span>
                    <PersianNumber>
                      {this.props.selectedOrder.invoice_number}
                    </PersianNumber>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <span style={{ fontWeight: "bold" }}>مجموع سفارش: </span>
                    <PersianNumber>
                      {this.props.selectedOrder.total_price}
                    </PersianNumber>
                  </Col>
                  <Col xs={6}>
                    <span style={{ fontWeight: "bold" }}>تاریخ: </span>
                    <PersianNumber>
                      {new PersianDate(this.props.selectedOrder.date).format()}
                    </PersianNumber>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <span style={{ fontWeight: "bold" }}>پشتیبان:</span>
                    <PersianNumber>
                      {this.props.selectedOrder.creator &&
                        this.props.selectedOrder.creator.username}
                    </PersianNumber>
                  </Col>
                  <Col xs={6}>
                    <span style={{ fontWeight: "bold" }}>راننده: </span>
                    <PersianNumber>
                      {`${
                        this.props.selectedOrder.driver &&
                        this.props.selectedOrder.driver.firstName
                      } ${
                        this.props.selectedOrder.driver &&
                        this.props.selectedOrder.driver.lastName
                      } `}
                    </PersianNumber>
                  </Col>
                </Row>
                <ExportExcelLink orderId={this.props.selectedOrder._id} />
                <hr />
                <Table striped hover>
                  <thead>
                    <tr>
                      <th className="text-right">شماره</th>
                      <th className="text-right">نام</th>
                      <th className="text-right">قیمت واحد</th>
                      <th className="text-right">واحد</th>
                      <th className="text-right">مساحت</th>
                      <th className="text-right">قیمت کل</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.selectedOrder.services.map((prop, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            <PersianNumber arabic={false}>
                              {key + 1}
                            </PersianNumber>
                          </td>
                          <td>{prop.name}</td>
                          <td>
                            <PersianNumber arabic={false}>
                              {prop.price}
                            </PersianNumber>
                          </td>
                          <td>
                            <PersianNumber arabic={false}>
                              {prop.count || 1}
                            </PersianNumber>
                          </td>
                          <td>
                            <PersianNumber arabic={false}>
                              {prop.area || 1}
                            </PersianNumber>
                          </td>
                          <td>
                            <PersianNumber arabic={false}>
                              {(prop.area || 1) *
                                (prop.count || 1) *
                                (prop.price || 1)}
                            </PersianNumber>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            }
          />
        </Col>
      </Row>
    );
  }
}

const SingleOrderConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleOrder);

export default SingleOrderConnect;
